import Rollbar from 'rollbar';
import checkIgnore from '@hub/common/src/checkIgnore';

const baseConfig = {
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NODE_ENV
};

export const clientConfig = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  source_map_enabled: true,
  code_version: process.env.NEXT_PUBLIC_CODE_VERSION,
  ...baseConfig
};

export const serverInstance = new Rollbar({
  accessToken: process.env.ROLLBAR_SERVER_TOKEN,
  ...baseConfig,
  checkIgnore
});
